import { StatelessComponent, ReactNode } from 'react'
import { getSaveButtonFormProps } from 'helpers/formHelpers'
import Button from 'components/features/pfm/Button/Button'
import { ReduxFormProps } from 'interfaces/component'

type SubmitButtonProps = ReduxFormProps & {
  children: ReactNode
}

const SubmitButton: StatelessComponent<SubmitButtonProps> = ({ children, ...rest }) => {
  return (
    <Button { ...getSaveButtonFormProps(rest) } submit fullWidth qaMarker='submit-button'>
      { children }
    </Button>
  )
}

export default SubmitButton
